export enum FORM_FIELDS {
  FIRST_NAME = 'firstName',
  PROEJCT_NAME = 'projectName',
}
